
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { RoleDetailVM } from 'src/app/viewModels/role/role-detail-vm';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { RoleService } from '../services/role.service';
import { PermissionService } from '../../permissions/services/permission/permission.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-edit-roles',
  templateUrl: './edit-roles.component.html',
  styleUrls: ['./edit-roles.component.scss']
})
export class EditRolesComponent implements OnInit {
  
  currentUser: any;
  databaseId: string;
  organizationId: string;
  OfficeIDList: any=[];
  myOfficeID: any;
  
  constructor(private fb: FormBuilder,
    private roleService: RoleService, private toastr: ToastrService,
    private statusConst: StatusConstant, private loader: LoaderService,
    private permissionService: PermissionService, private paginationVm: PaginationViewModel,
    private mulstiselect: MultiselectVM,  private commonService: CommonService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,) {

      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);

      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });

    this.updateRoleDetailform = this.fb.group({
      roleName: ['', Validators.required],
      roleDescription: ['', Validators.required],
      selectedPermission: [''],
      //selectedPermission: ['', Validators.required],
      isActive: ['']
    });
    let data = [];
    data = this.commonService.getEditData();
    if(data !=undefined){
      this.isEdit = data[0];
      this.role = data[1];
  
      this.updateRoleDetail.description = this.role.description;
      this.updateRoleDetail.roleName = this.role.roleName;
      this.updateRoleDetail.roleID = this.role.roleID;
      this.updateRoleDetail.isActive = this.role.isActive;
      //this.updateRoleDetail.isActive = this.role.isActive === 'Active' ? true : false;
      let permissiontemp = this.role.permissions.map(t=>t.permissionID);
      this.updateRoleDetail.rolePermissions = permissiontemp;
      
      let tempArray = [];
      this.role.permissions.forEach(perm => {
        let copyModel = Object.assign({}, this.mulstiselect);
        copyModel.item_id = perm.permissionID;
        copyModel.item_text = perm.permissionName;
        tempArray.push(copyModel);
      });
      this.selectedItems = tempArray;
    }      
   }


  updateRoleDetailform: FormGroup;
  updateRoleDetail: RoleDetailVM = new RoleDetailVM();
  isEdit: boolean;
  role: any;
  updatePermissionResponseHolder: any;
  permissionResponseHolder: any;
  permList: any[] = [];
  tempArrayToHoldPermission: any[] = [];
  dropdownList: any[] = [];
  dropdownSettings = {};
  selectedItems = [];
  @Output() closeSidePanel = new EventEmitter();
  closePannel:boolean = false;

  
  ngOnInit(): void {
    this.paginationVm.pageSize = 0;
    this.paginationVm.pageIndex = 0;
    this.paginationVm.OfficeIDList=[];
    this.getPermissionData();
    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
     // itemsShowLimit: 3,
      allowSearchFilter: true
    };

    // this.selectedItems = [
    //   { item_id: 3, item_text: 'Pune' },
    //   { item_id: 4, item_text: 'Navsari' }
    // ];
  }



  @Output() getcloseCreateRole = new EventEmitter<boolean>();



  close(any) {
    let closePanel = false;
    this.closeSidePanel.emit(closePanel);
    this.getcloseCreateRole.emit(any);
  }
  

   updateRole(){
      let roleDetails = new RoleDetailVM();
      this.updateRoleDetail.OrganizationID = Number(sessionStorage.getItem('organizationID'));
      roleDetails = this.updateRoleDetail;
      this.loader.show();

      roleDetails.rolePermissions= [];//this.selectedItems;

      this.selectedItems.forEach(element => {
        roleDetails.rolePermissions.push(Number(element.item_id));
       });
      
      this.roleService.editRole(roleDetails).subscribe(response=>{
      this.updatePermissionResponseHolder = response;
      this.loader.hide();
      
      if (this.updatePermissionResponseHolder.status === this.statusConst.statusSuccess) {
        this.toastr.success("Role updated successfully.", '', {
          timeOut: 3000,
        });
        let closePanel = true;
        this.closeSidePanel.emit(closePanel);
      } else {
        this.loader.hide();
        this.toastr.error(this.updatePermissionResponseHolder.message, '', {
          timeOut: 3000,
        });
      }
    });
  }

  getPermissionData() {
    this.loader.show();
    var ReqModel={
      pageIndex: 0,
      pageSize: 0,    
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID:this.myOfficeID
    }
    this.permissionService.getAllPermissions(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.permissionResponseHolder = response;
        this.permList = this.permissionResponseHolder.data.permissionsModel;       
        this.permList.forEach(perm => {
          let copyModel = Object.assign({}, this.mulstiselect);
          copyModel.item_id = perm.permissionID;
          copyModel.item_text = perm.permissionName;
          this.tempArrayToHoldPermission.push(copyModel);
        });
        this.dropdownList = this.tempArrayToHoldPermission;
      }
      this.loader.hide();
    });

  }

}
